<div class="spacer">
  <div class="links">
    @if (!hideGroceries) {
      @if (!groceries.button) {
        <a class="nav products" [routerLink]="groceries.url" routerLinkActive="active">{{ groceries.name }}</a>
      } @else {
        <app-text-button class="nav" [routerLink]="groceries.url" routerLinkActive="active">
          {{ groceries.name }}
        </app-text-button>
      }
    }

    @for (link of links; track $index) {
      @if (link.type === 'link') {
        @let sameSiteLink = sameSite(link);
        @if (sameSiteLink) {
          <a class="nav" [routerLink]="sameSiteLink.targetUrl" [target]="sameSiteLink.new ? '_blank' : '_self'" routerLinkActive="active">
            {{ sameSiteLink.titleText }}
          </a>
        } @else {
          <a class="nav" [href]="link.targetUrl" [target]="link.new ? '_blank' : '_self'">{{ link.titleText }}</a>
        }
      }

      @if (link.type === 'subNav') {
        <div class="sub-nav">
          <a
            [class.no-pointer]="!link.link"
            [class.open]="openNavigationName === link.title"
            class="nav"
            (mouseenter)="openNavigation(navContent, link.title)"
            (focus)="openNavigation(navContent, link.title)"
            [routerLink]="link.link ? [link.link] : []"
            [routerLinkActive]="link.link ? 'active' : ''"
            (click)="link.link && closeNavigation()"
            [target]="link.linkTarget"
            tabindex="0"
          >
            {{ link.title }}
          </a>
          <div class="sub-nav-content" [class.display]="openNavigationName === link.title" tabindex="-1" #navContent>
            <div>
              @for (link of link.pages; track $index) {
                @let sameSiteLink = sameSite(link);
                @if (sameSiteLink) {
                  <a
                    class="nav small"
                    [routerLink]="sameSiteLink.targetUrl"
                    routerLinkActive="active"
                    [target]="sameSiteLink.new ? '_blank' : '_self'"
                    (click)="closeNavigation()"
                  >
                    {{ sameSiteLink.titleText }}
                  </a>
                } @else {
                  <a class="nav small" [href]="link.targetUrl" [target]="link.new ? '_blank' : '_self'" (click)="closeNavigation()">
                    {{ link.titleText }}
                  </a>
                }
              }
            </div>
          </div>
        </div>
      }

      @if (link.type === 'burger') {
        <div class="burger-nav">
          <a
            [class.no-pointer]="!link.link"
            [class.open]="openNavigationName === link.title"
            class="nav"
            (mouseenter)="openNavigation(navContent, link.title)"
            (focus)="openNavigation(navContent, link.title)"
            [routerLink]="link.link ? [link.link] : []"
            [routerLinkActive]="link.link ? 'active' : ''"
            (click)="link.link && closeNavigation()"
            [target]="link.linkTarget"
            tabindex="0"
          >
            {{ link.title }}
          </a>
          <div class="burger-nav-content" [class.display]="openNavigationName === link.title" tabindex="-1" #navContent>
            <div>
              @for (link of link.pages; track $index) {
                @let sameSiteLink = sameSite(link);
                @if (sameSiteLink) {
                  <a
                    class="nav"
                    [routerLink]="sameSiteLink.targetUrl"
                    routerLinkActive="active"
                    [target]="sameSiteLink.new ? '_blank' : '_self'"
                    (click)="closeNavigation()"
                  >
                    {{ sameSiteLink.titleText }}
                  </a>
                } @else {
                  <a class="nav" [href]="link.targetUrl" [target]="link.new ? '_blank' : '_self'" (click)="closeNavigation()">
                    {{ link.titleText }}
                  </a>
                }
              }
            </div>
          </div>
        </div>
      }

      @if (link.type === 'categoryBurger') {
        <div class="burger-nav">
          <a
            [class.no-pointer]="!link.link"
            [class.open]="openNavigationName === link.title"
            class="nav"
            (mouseenter)="openNavigation(navContent, link.title)"
            (focus)="openNavigation(navContent, link.title)"
            [routerLink]="link.link ? [link.link] : []"
            [routerLinkActive]="link.link ? 'active' : ''"
            (click)="link.link && closeNavigation()"
            [target]="link.linkTarget"
            tabindex="0"
          >
            {{ link.title }}
          </a>
          <div class="burger-nav-content" [class.display]="openNavigationName === link.title" tabindex="-1" #navContent>
            <div>
              @for (link of link.pages; track $index) {
                @let sameSiteLink = sameSite(link);
                @if (sameSiteLink) {
                  <a
                    class="nav"
                    [routerLink]="sameSiteLink.targetUrl"
                    routerLinkActive="active"
                    [target]="sameSiteLink.new ? '_blank' : '_self'"
                    (click)="closeNavigation()"
                  >
                    {{ sameSiteLink.titleText }}
                  </a>
                } @else {
                  <a class="nav" [href]="link.targetUrl" [target]="link.new ? '_blank' : '_self'" (click)="closeNavigation()">
                    {{ link.titleText }}
                  </a>
                }
              }
            </div>
          </div>
        </div>
      }
    }
  </div>
  <!--<div class="actions">
     <app-product-search [placeholder]="searchPlaceholder" [searchButton]="searchButton"></app-product-search>
  </div> -->
  @if (showSocials) {
    <div class="socials">
      @if (socials.facebook) {
        <a [href]="socials.facebook" target="_blank" aria-label="Facebook">
          <mat-icon svgIcon="facebook" alt="Facebook"></mat-icon>
        </a>
      }
      @if (socials.instagram) {
        <a [href]="socials.instagram" target="_blank" aria-label="Instagram">
          <mat-icon svgIcon="instagram" alt="Instagram"></mat-icon>
        </a>
      }
      <a [routerLink]="contactUsLink" routerLinkActive="active" aria-label="Kontakt os"
        ><mat-icon svgIcon="contact" alt="Kontakt os" class="contact"></mat-icon
      ></a>
    </div>
  }
</div>
